import { checkDefined, checkGreaterThan } from 'faro-common-model';
export function toTenantConfiguration(tenantConfiguration) {
    checkDefined(tenantConfiguration.sessionTimeout, 'TenantConfiguration', 'sessionTimeout');
    checkGreaterThan(tenantConfiguration.sessionTimeout, 0, 'TenantConfiguration', 'sessionTimeout');
    return {
        sessionTimeout: tenantConfiguration.sessionTimeout,
        hasEdcConfiguration: tenantConfiguration.hasEdcConfiguration,
        userLinksEnabled: tenantConfiguration.userLinksEnabled,
    };
}
//# sourceMappingURL=tenant-configuration.js.map